<agr-page-toolbar
  [pageTitle]="'app.employee.navigation.relations' | translate"
  [isEmpty]="emptyCustomers()"
  emptyTitle="{{ 'app.no_results_title' | translate }}"
  emptyDescription="{{ 'app.employee.relations.no_relations_found' | translate }}"
  [emptyImage]="isAgrifirm ? 'assets/images/delivery.jpg' : ''"
>
  <ng-container actions>
    <button
      mat-flat-button
      type="button"
      color="accent"
      (click)="addRelation()"
      data-test="relation__add"
    >
      <mat-icon>add</mat-icon>
      {{ 'add' | translate }}
    </button>
  </ng-container>
  <ng-container [agrBlockSpinner]="customers() === undefined">
    @if (loadFailed()) {
      <div
        class="wrapper--spacing-horizontal spacing--margin-bottom"
        data-test="employee-relations__load-failed"
      >
        {{ 'app.errormsg.not_loaded' | translate }}
      </div>
    } @else if (customers(); as customers) {
      @if (!emptyCustomers()) {
        <mat-nav-list>
          @for (customer of customers; track customer.customerExternalId) {
            <a
              href="#"
              mat-list-item
              data-test="employee-relations__item"
              class="listItem"
              [routerLink]="['/employees', employeeId, 'relations', 'add']"
              [queryParams]="{ customerId: customer.customerExternalId }"
            >
              <mat-icon matListItemAvatar>
                {{
                  customer.hasCustomerRelation || customer.shipToRelationCount > 0
                    ? 'link'
                    : 'link_off'
                }}
              </mat-icon>
              <div matListItemTitle class="text--h6" data-test="employee-relations__name">
                {{ customer.name }}
              </div>
              <div matListItemLine class="text--small">
                {{ customer.emailAddress }}
                <span class="text--gray">
                  {{ customer.street }} {{ customer.houseNumber }}
                  {{ customer.houseNumberAddition }} {{ customer.postalCode }}
                  {{ customer.city }}
                  @if (customer.country) {
                    ({{ 'app.countries.' + customer.country | translate }})
                  }
                </span>
              </div>
              <div matListItemLine class="text--gray employee-relations__authorizations">
                @if (customer.hasCustomerRelation) {
                  <span>{{ 'app.employee.relations.customer_relation' | translate }}</span>
                }
                @if (customer.shipToRelationCount > 0) {
                  <span>
                    {{ customer.shipToRelationCount }}
                    {{ 'app.employee.relations.shipto_relation' | translate }}
                  </span>
                }
              </div>
              <button matListItemMeta mat-icon-button (click)="$event.preventDefault()">
                <mat-icon iconPositionEnd>edit</mat-icon>
              </button>
            </a>
          }
          <mat-divider></mat-divider>
        </mat-nav-list>
      }
    }
  </ng-container>
</agr-page-toolbar>
